import { hexToRgbaWithOpacity } from '@/utils/hexToRgbaWithOpacity';
import { Theme } from '@mui/material';

const getIconStyles = (color: string) => ({
  bgcolor: hexToRgbaWithOpacity(color, 0.1),
  width: '40px',
  height: '40px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

const getSmallIconStyles = (color: string) => ({
  bgcolor: hexToRgbaWithOpacity(color, 0.1),
  width: '34px',
  height: '34px',
  borderRadius: '9px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

const getCardSx = (theme?: any) => ({
  background: 'white',
  borderRadius: '14px',
  padding: theme ? theme.spacing(2) : '1rem 1.25rem',
  width: '100%',
  border: `1px solid ${theme ? theme.palette.divider : '#E2DFE8'}`,
  boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 2px 6px rgba(0,0,0,0.02)',
  cursor: 'pointer',
  transition:
    'box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease',
  '&:hover': {
    boxShadow: '0 8px 24px -4px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)',
    transform: 'translateY(-2px)',
    borderColor: theme ? `${theme.palette.primary.main}30` : undefined,
  },
});

const cardHoverSx = {
  boxShadow: '0 8px 24px -4px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)',
  transform: 'translateY(-2px)',
  borderColor: 'rgba(87, 46, 136, 0.18)',
} as const;

const tabButtonSx = (isActive: boolean, theme?: Theme) => ({
  textTransform: 'none' as const,
  fontFamily: 'Inter, sans-serif',
  fontSize: theme?.fontSizes.body,
  fontWeight: isActive ? 600 : 400,
  bgcolor: isActive
    ? `${theme?.palette.primary.main}20`
    : `${theme?.palette.primary.main}5`,
  color: isActive ? theme?.palette.primary.main : `currentColor`,
  border: isActive
    ? `1px solid ${theme?.palette.primary.main}`
    : `1px solid ${theme?.palette.primary.main}30`,
  borderRadius: '12px',
  boxShadow: 'none',
  px: { xs: 0, md: 2 },
  py: 1,
  minHeight: '36px',
  flex: { xs: 1, md: 'auto' },
  transition: 'background-color 0.2s ease, color 0.2s ease',
  '&:hover': {
    bgcolor: `${theme?.palette.primary.main}10`,
  },
  '&:active': { transform: 'scale(0.97)' },
});

export {
  getIconStyles,
  getSmallIconStyles,
  getCardSx,
  cardHoverSx,
  tabButtonSx,
};
